import { DataGrid, GridColumnsConfigProvider } from '@finbeat/react-toolkit';
import DataTimeText from 'components/Common/DataTime';
import Money from 'components/Common/Money';
import { CalcCover } from 'models/api/order';
import DataGridProp from 'models/dataGridProp';
import { Trans, useTranslation } from 'react-i18next';

type OrderCalcCoversTableType = CalcCover & DataGridProp;

const OrderCalcCoversTable = ({ covers }: { covers: CalcCover[] }) => {
    useTranslation();
    return (
        <GridColumnsConfigProvider<OrderCalcCoversTableType>
            storagePath="payment-covers-grid"
            initColumns={[
                {
                    key: 'coveredAmount',
                    name: <Trans i18nKey="BackOfficeCoverageAmount" />,
                    cellClass: 'base-data-grid__normal-line-height',
                    formatter: ({ row }) => (
                        <>
                            <div>
                                <Money value={row.coveredAmount} />
                            </div>
                            <small className="text-muted">
                                <DataTimeText value={row.coveredDt} />
                            </small>
                        </>
                    ),
                },
                {
                    key: 'paymentSource',
                    name: <Trans i18nKey="BackOfficePaymentSource" />,
                },
                {
                    key: 'paymentAmount',
                    name: <Trans i18nKey="BackOfficePaymentAmount" />,
                    cellClass: 'base-data-grid__normal-line-height',
                    formatter: ({ row }) => (
                        <>
                            <div>
                                <Money value={row.paymentAmount} />
                            </div>
                            <small className="text-muted">
                                <DataTimeText value={row.paymentDt} />
                            </small>
                        </>
                    ),
                },
                {
                    key: 'paymentReferenceId',
                    name: <Trans i18nKey="BackOfficeExternalCode" />,
                },
            ]}
        >
            <DataGrid<OrderCalcCoversTableType>
                rows={covers}
                lineHeight={45}
                reactDataGreedProps={{
                    defaultColumnOptions: {
                        sortable: true,
                        resizable: true,
                    },
                }}
                blockSize={60 + covers.length * 45}
                minBlockSize={70}
            />
        </GridColumnsConfigProvider>
    );
};

export default OrderCalcCoversTable;
